module.exports = __webpack_public_path__ + "static/finalLogo-eafb6eb98eaf6fd40e8a93e712f673e6.png";